import { Component, OnInit } from '@angular/core';
import { IArticle } from '../../core/models/IArticle.type';
import { DataService } from '../../core/services/data.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
})
export class HomeComponent implements OnInit {
  articles:IArticle[];
  utilities:IArticle[];
  numberOfArticles = 8;

  guides:any[];

  constructor(private router: Router, private dataServices: DataService) { 
    setTimeout(() => {
      this.utilities = [
        {title: "Unsplash - Photos for everyone. The internet's source of freely-usable images.", description: "", image: "./assets/images/unsplash.jpg", link: "https://unsplash.com/"},
        {title: "Pexels. The best free stock photos & videos shared by talented creators.", description: "", image: "./assets/images/pexels.jpg", link: "https://www.pexels.com/"},
        {title: "Pixabay. Stunning free images & royalty free stock", description: "", image: "./assets/images/pixabay.jpg", link: "https://pixabay.com/"},
        {title: "Freepik - Vector, Photo, PSD. Graphic resources for everyone", description: "", image: "./assets/images/freepick.jpg", link: "https://www.freepik.com/"},
  
        //{title: "Guida estensioni dei file", description: "Guida estensioni dei file", image: "./assets/images/default.jpg", link: "#"},
        {title: "Convertire .Pdf in Word", description: "", image: "./assets/images/default.jpg", link: "https://www.convertpdftoword.net/"},
        //{title: "ConnectionStrings", description: "ConnectionStrings", image: "./assets/images/default.jpg", link: "#"},
        {title: "ConnectionStrings, helps developers connect software to data.", description: "", image: "./assets/images/default.jpg", link: "https://www.connectionstrings.com/"}
      ]
    }, 400);
  }

  ngOnInit(): void {
    this.getLatestArticles();
    this.getGuides();
  }

  getLatestArticles(){
    this.dataServices.getLatestArticle(this.numberOfArticles).subscribe(data=>{
      if(data){
        this.articles = data.result;
      }
    })
  }
  
  getSingleArticle(environment, category, articleId){
    console.log("environment, category, articleId", environment, category, articleId)
    this.router.navigate(['articles/' + environment + '/'+ category + '/article-details/' + articleId]);
  }

  getGuides(){
    this.dataServices.getGuides().subscribe(data=>{
      if(data){
        this.guides = data.result[0];
      }
    })
  }
}
